import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { CantBackGuard } from './shared/guards/cant-back.guard';
import { CheckLoginGuard } from './shared/guards/check-login.guard';
// core from Silegal App
//import { LoginComponent } from './auth/components/login/login.component';
import { VerifiedComponent } from './featured-modules/components/verified/verified.component';
import { NotVerifiedComponent } from './featured-modules/components/not-verified/not-verified.component';
import { MaintenanceComponent } from './featured-modules/components/maintenance/maintenance.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren:()=> import('./auth/auth.module').then(m=>m.AuthModule)
/*     canActivate: [CantBackGuard], */
  },
  {
    path: 'dashboard',
    loadChildren:()=> import('./featured-modules/featured-modules.module').then(m=>m.FeaturedModulesModule),
    canActivate: [CheckLoginGuard]
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'verified',
    component: VerifiedComponent
  },
  {
    path: 'nverified',
    component: NotVerifiedComponent
  },
  {
    path: '**',
    component: MaintenanceComponent
    /* loadChildren:()=> import('./featured-modules/featured-modules.module').then(m=>m.FeaturedModulesModule) */
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
       useHash: true 
     
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
